import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";

const menuLinks = [
  { id: "about", label: "About", href: "#about" },
  { id: "team", label: "Team", href: "#team" },
  { id: "services", label: "Divisions", href: "#services" },
  { id: "products", label: "Products", href: "#gallery" },
  { id: "contact", label: "Contact", href: "#contact" },
];

export const Navigation = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [opacity, setOpacity] = useState(1);
  const [height, setHeight] = useState(80);
  const [logoHeight, setLogoHeight] = useState(50);
  const [activeLink, setActiveLink] = useState("about");

  const location = useLocation();
  const navigate = useNavigate();

  const handleLogoClick = () => {
    if (location.pathname === "/") {
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      navigate("/");
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const newOpacity = scrollY < 100 ? 1 - scrollY / 500 : 0.4;
      const newHeight = scrollY < 100 ? 80 - scrollY / 5 : 50;
      const newLogoHeight = scrollY < 100 ? 50 - scrollY / 6 : 35;
      setOpacity(newOpacity);
      setHeight(newHeight);
      setLogoHeight(newLogoHeight);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Prevent background scroll when menu is open
  useEffect(() => {
    document.body.style.overflow = mobileMenuOpen ? "hidden" : "auto";
  }, [mobileMenuOpen]);

  return (
    <>
      <nav
        style={{
          backgroundColor: `rgba(255, 255, 255, ${opacity})`,
          boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
          position: "fixed",
          top: 0,
          width: "100%",
          zIndex: 1999,
          backdropFilter: "blur(10px)",
        }}
      >
        <div
          style={{
            maxWidth: "1000px",
            margin: "0 auto",
            padding: "0 2rem",
            height: `${height}px`,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            transition: "all 0.3s ease",
          }}
        >
          {/* Logo */}
          <a
            href="/"
            onClick={handleLogoClick}
            style={{ display: "flex", alignItems: "center" }}
          >
            <img
              src="/img/logo/tahil_logo_vector.png"
              alt="Tahıl Logo"
              loading="lazy"
              style={{
                height: `${logoHeight}px`,
                cursor: "pointer",
                transition: "height 0.3s ease",
              }}
            />
          </a>

          {location.pathname === "/" ? (
            <>
              {/* Desktop Menu */}
              <ul
                className="desktop-menu"
                style={{
                  listStyle: "none",
                  display: "flex",
                  gap: "3rem",
                  margin: 0,
                  padding: 0,
                }}
              >
                {menuLinks.map(({ id, label, href }) => (
                  <li key={id}>
                    <a
                      href={href}
                      onClick={() => setActiveLink(id)}
                      className={`nav-link ${activeLink === id ? "active" : ""}`}
                      style={{
                        textDecoration: "none",
                        color: "#222",
                        fontWeight: 600,
                        fontSize: "1.6rem",
                        position: "relative",
                        paddingBottom: 6,
                        transition: "color 0.3s ease",
                      }}
                    >
                      {label}
                    </a>
                  </li>
                ))}
              </ul>

              {/* Hamburger Button */}
              <button
                className="mobile-hamburger"
                aria-label="Open menu"
                onClick={() => setMobileMenuOpen(true)}
                style={{
                  background: "none",
                  border: "none",
                  display: "none",
                  fontSize: "2rem",
                  cursor: "pointer",
                }}
              >
                <svg width="30" height="30" viewBox="0 0 100 80" fill="#C38745">
                  <rect width="100" height="12"></rect>
                  <rect y="30" width="100" height="12"></rect>
                  <rect y="60" width="100" height="12"></rect>
                </svg>
              </button>
            </>
          ) : (
            <button
              onClick={() => navigate("/")}
              style={{
                background: "none",
                border: "none",
                fontSize: "1.3rem",
                color: "#333",
                fontWeight: 600,
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                gap: 8,
              }}
            >
              <FaArrowLeft size={16} style={{ color: "#C38745" }} />
              Back to Home
            </button>
          )}
        </div>
      </nav>

      {/* Mobile Menu Overlay */}
      {mobileMenuOpen && (
        <div
          className="mobile-menu-overlay"
          onClick={() => setMobileMenuOpen(false)}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(255, 255, 255, 0.98)",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 2000,
            animation: "fadeIn 0.3s ease",
          }}
        >
          <button
            aria-label="Close menu"
            onClick={() => setMobileMenuOpen(false)}
            style={{
              position: "absolute",
              top: 24,
              right: 24,
              background: "none",
              border: "none",
              cursor: "pointer",
              padding: 8,
            }}
          >
            <svg
              width="32"
              height="32"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#222"
              strokeWidth="3"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>

          <ul
            style={{
              listStyle: "none",
              padding: 0,
              margin: 0,
              textAlign: "center",
            }}
          >
            {menuLinks.map(({ id, label, href }) => (
              <li key={id} style={{ margin: "2rem 0" }}>
                <a
                  href={href}
                  onClick={() => setMobileMenuOpen(false)}
                  style={{
                    color: "rgb(195, 135, 69)",
                    fontSize: "2.4rem",
                    fontWeight: 700,
                    textDecoration: "none",
                  }}
                >
                  {label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}

      <style>{`
        @keyframes fadeIn {
          from {opacity: 0;}
          to {opacity: 1;}
        }

        @media (max-width: 768px) {
          .desktop-menu {
            display: none !important;
          }

          .mobile-hamburger {
            display: inline-flex !important;
          }
        }

        .nav-link::after {
          content: '';
          position: absolute;
          width: 0;
          height: 2px;
          bottom: 0;
          left: 0;
          background-color: #222;
          transition: width 0.3s ease, background-color 0.3s ease;
        }

        .nav-link:hover::after {
          width: 100%;
        }

        .nav-link:hover {
          color: #000;
        }

        .nav-link.active::after {
          width: 100%;
          background-color: #C38745;
        }

        .nav-link.active {
          color: #C38745;
        }
      `}</style>
    </>
  );
};
